import { render } from "./StatusLabel.vue?vue&type=template&id=17d38739&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=17d38739&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d38739"]])

export default __exports__